<div class="label" *ngIf="label" role="text">
  <span role="text">{{ label }}</span>

  <span class="btn-wrapper">
    <button
      type="button"
      class="btn btn-md color-white rounded-pill"
      [ngClass]="{ 'btn-grey': display, 'btn-primary': !display }"
      (click)="addField()"
    >
      Adicionar sugestão
    </button>
    <button
      type="button"
      class="btn btn-md color-white rounded-pill bg-color-grey"
      [ngClass]="{ 'btn-red': display, 'btn-grey': !display }"
      (click)="removeField()"
    >
      Remover sugestão
    </button>
  </span>
</div>
<ng-container *ngIf="display">
  <textarea
    [name]="name"
    [id]="id"
    (input)="onChange($event.target.value)"
    (blur)="onTouched()"
    [disabled]="disabled"
    class="input"
    [value]="controlDir.control.value"
    [ngClass]="{
      error: controlDir && !controlDir.control.valid && controlDir.control.touched,
      success: controlDir && controlDir.control.valid && controlDir.control.touched
    }"
    #textarea
  ></textarea>
  <p
    [ngClass]="{
      'error-msg color-red': controlDir.value && controlDir.control.value.length > 5000
    }"
  >
    {{ controlDir.value ? controlDir.value.length : 0 }} / 5000
  </p>
  <ng-container *ngIf="controlDir && !controlDir.control.valid && controlDir.control.touched">
    <span class="error-msg color-red">
      {{
        controlDir.control.errors && !controlDir.control.errors.maxlength
          ? 'O preenchimento desse campo é obrigatório'
          : 'A quantidade de caracteres que você inseriu é maior que a permitida.'
      }}</span
    >
  </ng-container>
</ng-container>
